export const QWERTY = "qwertyuiopasdfghjklzxcvbnm"